
import { IGlobalState } from "@/store";
import { useStore } from "vuex";
import {
  computed,
  defineComponent,
  reactive,
  ref,
  toRefs,
  watch,
} from "vue";
import { applyAppApi } from "@/service/api";
import { ElMessage } from "element-plus";
import { IAPIItem } from "@/typings/apiManage";
import { useApiGroupList, useAPIList } from "@/hooks/apiManage";

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: "",
    },
    appId: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const state = reactive({
      type: 1,
      clickModalClose: false,
      selectAllStatu: false,
    });
    const store = useStore<IGlobalState>();
    const tableRef = ref<any>(null);
    const apis = computed(() => store.state.apiManage.modalAPI.apis);
    const selAPIList = ref<IAPIItem[]>([]);
    const currSelectionList = ref<IAPIItem[]>([]);
    const groups = computed(() => store.state.apiManage.groups);

    // 获取关键字
    const keyWord = computed({
      get: () => store.state.apiManage.modalAPI.keyWord,
      set: (val) => {
        store.state.apiManage.modalAPI.keyWord = val;
      },
    });

     // 分组id
    const groupId = computed({
      get: () => store.state.apiManage.modalAPI.groupId,
      set: (val) => {
        store.state.apiManage.modalAPI.groupId = val;
      },
    });
    /**
     * 获取分组列表
     */
    const getApiGroupData = async () => {
      await useApiGroupList(
        store
      );
    };

    // 获取当前页码数
    const page = computed({
      get: () => store.state.apiManage.modalAPI.apis.page,
      set: (val) => {
        store.state.apiManage.modalAPI.apis.page = val;
      },
    });

    /**
     * 获取接口列表
     */
    const getAPIs = async () => {
      await useAPIList(
        store,
        props.appId,
        groupId.value,
        keyWord.value,
        page.value,
        apis.value.limit
      );
    };

    /**
     * 搜索
     */
    async function handleSearch() {
      page.value = 1;
      await getAPIs();
    }
    /**
     * 关闭弹窗
     */
    function handleClose() {
      context.emit("close-modal");
      selAPIList.value = [];
      currSelectionList.value = [];
      page.value = 1;
      groupId.value = '';
      keyWord.value = '';
    }
    /**
     * 获取已选接口id
     */
    function getAPIIds() {
      let ids = "";
      ids = selAPIList.value
        .map(function (elem) {
          return elem.id;
        })
        .join(",");

      return ids;
    }
    /**
     * 点击授权
     */
    async function authAPI() {
      const ids: string = getAPIIds();
      if(!ids){
        ElMessage({ message: '请选择API接口', type: "error" });
        return;
      }

      const params = {
        appId: props.appId,
        ids: ids,
        userId: props.userId,
      };
      const result = await applyAppApi(params);
      if (result.code == 1) {
        ElMessage({ message: "授权成功", type: "success" });
        handleClose();
        context.emit("update-table");
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
    }
    /**
     * 点击添加或移除
     */
    function tableRowClick(row: IAPIItem) {
      // 当该行已经被选中过
      selAPIList.value.forEach(function (item: IAPIItem, index: number) {
        if (row.id === item.id) {
          selAPIList.value.splice(index, 1);
        }
      });
      tableRef.value.toggleRowSelection(row);
    }
    /**
     * 表格选项发生变化
     */
    function selectionChange(vals: IAPIItem[]) {
      const _selectionList = JSON.parse(JSON.stringify(selAPIList.value));
      currSelectionList.value = JSON.parse(JSON.stringify(vals));

      if (vals.length) {
        if (!selAPIList.value.length) {
          selAPIList.value = JSON.parse(JSON.stringify(vals));
        } else {
          vals.forEach(function (item, index) {
            for (let i = 0; i < selAPIList.value.length; i++) {
              if (item.id === selAPIList.value[i].id) {
                break;
              } else if (i + 1 === selAPIList.value.length) {
                _selectionList.push(vals[index]);
              }
            }
          });
          selAPIList.value = JSON.parse(JSON.stringify(_selectionList));
        }
      }
      state.selectAllStatu = vals.length === apis.value.rows.length;
    }
    /**
     * 删除选择的临时标签
     */
    function removeItem(index: number) {
      const _tagId: string = selAPIList.value[index].id;
      let _tagIndex: any = "null";

      for (let i = 0; i < apis.value.rows.length; i++) {
        if (_tagId === apis.value.rows[i].id) {
          _tagIndex = i;
          break;
        }
      }
      selAPIList.value.splice(index, 1);
      if (_tagIndex !== "null") {
        tableRef.value.toggleRowSelection(apis.value.rows[_tagIndex]);
      }
      if (selAPIList.value.length === 0) {
        state.selectAllStatu = false;
      }
    }
    /**
     * 全选
     */
    function handleSelectAll(statu: boolean) {
      if (!statu) {
        let _differ = 0; // 差异值
        const _selectionList = JSON.parse(JSON.stringify(selAPIList.value));
        // 当取消全选时剔除选中项
        selAPIList.value.forEach(function (item, index) {
          for (let i = 0; i < currSelectionList.value.length; i++) {
            if (currSelectionList.value[i].id === item.id) {
              _selectionList.splice(index - _differ, 1);
              _differ++;
              break;
            }
          }
        });
        selAPIList.value = JSON.parse(JSON.stringify(_selectionList));
      }
      tableRef.value.toggleAllSelection();
    }
    watch(
      () => props.dialogVisible,
      async (newVal) => {
        if (newVal) {
          await getApiGroupData();
          await getAPIs();
        }
      }
    );
    return {
      ...toRefs(state),
      tableRef,
      apis,
      selAPIList,
      keyWord,
      groups,
      groupId,
      page,
      getAPIs,
      handleSearch,
      tableRowClick,
      selectionChange,
      removeItem,
      authAPI,
      handleClose,
      handleSelectAll
    };
  },
});
